import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ResponseService } from './../../_models';

@Injectable({
  providedIn: 'root',
})
export class UsuariosServicesService {
  public respuestaGenerica: ResponseService;

  constructor(private http: HttpClient) {}

  getRoles(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/Usuarios/GetRoles`);
  }

  getUsuarios(rol: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/Usuarios/GetUsuarioRole/${rol}`);
  }

  getAsociadoById(id: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/Asociado/ById/${id}`);
  }

  /** Los eventos de la membresía de la sesión: los del autoservicio no tienen RFC. */
  getMisEventos(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/Eventos/MisEventos`);
  }

  CambioPassword(data: any) {
    return this.http
      .patch<any>(`${environment.apiUrl}/api/Usuarios/CambioPassword`, data)
      .pipe(
        map((respuesta) => {
          this.respuestaGenerica = {
            hasError: respuesta.hasErrors,
            hasWarning: respuesta.hasWarnings,
            ErrorMsg: respuesta.errorsString,
            WarningMsg: respuesta.warningsString,
            valoresDinamicos: respuesta.dynamicProperties,
            hasResultado: respuesta.hasDynamicProperties,
          };
          return this.respuestaGenerica;
        })
      );
  }

  saveUsuarioData(datosUsuario: any) {
    return this.http.post(
      environment.apiUrl + environment.postUsuario,
      datosUsuario
    );
  }

  deleteUsuario(UserName: string) {
    return this.http.delete(
       `${environment.apiUrl}/api/Usuarios/EliminaUsuario/${UserName}`
    );
  }

  updateEmailAsociado(correo: string, idMembresia: number) {
    return this.http.patch(
      `${environment.apiUrl}/api/Usuarios/UpdateEmailAsociado`,
      { correo, idMembresia }
    );
  }

}
